export function isEmpty(content?: string[]): boolean {
  return content === undefined || content.length === 0;
}
